"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ErrorIcon = function ErrorIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 32 32"
  }, props), _react.default.createElement("path", {
    d: "M30.5 32h-29a1.5 1.5 0 0 1-1.341-2.171l14.5-29a1.5 1.5 0 0 1 2.682 0l14.5 29A1.5 1.5 0 0 1 30.5 32zM3.928 29h24.146L16 4.854 3.928 29zM17.5 24.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001zM16 20.75a1.5 1.5 0 0 1-1.5-1.5V13.5a1.5 1.5 0 1 1 3 0v5.75a1.5 1.5 0 0 1-1.5 1.5z"
  }));
};

ErrorIcon.propTypes = {
  size: _propTypes.number
};
ErrorIcon.defaultProps = {
  size: 40
};
var _default = ErrorIcon;
exports.default = _default;